import { useEffect, useState } from 'react';
import { Typography } from '../../typography';
import { Button } from '../../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from '../ModalComponents';
import { enqueueSnackbar } from '../../snackbar';
import { useDeleteGateOutsByFilterMutation } from '../../../hooks';
import { MESSAGES } from '../../../const';
import { i18n } from '../../../i18n';
import { showToRoles } from '../../../utils';
import { useStoreUser } from '../../../context';

interface GateOutFilterDeleteModalType {
  id?: string;
  clientCode: string;
  submitClick: () => void;
  open: () => void;
}

export const gateOutFilterDeleteModal: GateOutFilterDeleteModalType = {
  id: '',
  clientCode: '',
  submitClick: () => null,
  open: () => null,
};

export const GateOutFilterDeleteModal = () => {
  const { user } = useStoreUser();
  const { mutate } = useDeleteGateOutsByFilterMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    gateOutFilterDeleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    gateOutFilterDeleteModal.id = '';
    gateOutFilterDeleteModal.clientCode = '';
    setOpen(false);
  };

  const handleSubmitClick = async () => {
    if (!gateOutFilterDeleteModal.id) return;

    mutate(gateOutFilterDeleteModal.id, {
      onSuccess: () => {
        handleOnClose();
        enqueueSnackbar(MESSAGES.GATE_OUT.SUCCESS.DELETED, 'success');
        gateOutFilterDeleteModal.submitClick();
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.GATE_OUT.ERROR.NOT_DELETED, 'error');
      },
    });
  };

  return (
    <ModalBase id={'gate-out-filter-delete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.gateFilterDeleteTitle')}
          {(showToRoles('admin', user) && `: ${gateOutFilterDeleteModal.clientCode}`) || ''}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
